import BaseComponent from '../../common/BaseComponent/BaseComponent';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import HelperCookie from "../../common/helpers/HelperCookie";
import {__t} from '../../common/lang/text-resource';

class ComponentCrispChat extends BaseComponent {

	greetings = {
		greeting_sales: __t('свързахте-се-с-търговски-отдел-с-какво-можем-да-в6b2b2d'),
		greeting_support: __t('свързахте-се-с-отдел-техническа-поддръжка-с-каквоc6700b'),
		name_sales: __t("Търговски отдел"),
		name_support: __t("Техническа поддръжка"),
		can_we_help: __t("С кой отдел желаете да се свържете?"),
		welcome: __t("Здравейте, С какво можем да Ви съдействаме?"),
	};

	isProcessed = false;

	constructor() {
		super(...arguments, 'ComponentCrispChat');
	}

	eventConsume(actionName) {
		//if (actionName === 'LawBannerAccepted') {
		//	const existingStyle = document.getElementById('lawBannerStyle')
		//	if (existingStyle !== null) {
		//		existingStyle.remove();
		//	}
		//}
	}

	componentDidMount() {
		this.loadCrispChat();
	}

	componentDidUpdate() {
		this.loadCrispChat();
	}

	loadCrispChat = () => {

		if (this.isProcessed) {
			return;
		}

		let data = this.context.get(this.componentName);
		if (data) {
			data = data.componentData;
		}
		if (!data) {
			return;
		}

		const {
			resetCrispSession,
			websiteId,
			isChatEnabled
		} = data;

		if (resetCrispSession) {
			let name = "crisp-client/session/" + websiteId;
			name = encodeURI(name);
			HelperCookie.setCookie(name, '', 0, data.cookieServer);
		}

		if (isChatEnabled) {
			this.loadChat(data);
		}

		this.isProcessed = true;
	}

	loadChat = (componentData) => {
		const {
			websiteId,
			isChatEnabled,
			arrDataSend,
			arrDataSet,
			languageCode
		} = componentData;

		// if (!isChatEnabled) {
		// 	return false;
		// }
		window.$crisp = [];
		window.$crisp.push(["safe", true]);

		if (typeof arrDataSend === 'object') {
			Object.keys(arrDataSend).map((key) => {
				let k = key;
				let v = arrDataSend[key];
				window.$crisp.push(["set", "session:data", [[[k, v]]]]);
			});
		}


		if (typeof arrDataSet === 'object') {
			Object.keys(arrDataSet).map((key) => {
				let k = key;
				let v = arrDataSet[key];
				window.$crisp.push(["set", k, v]);
			});

		}

		window.CRISP_WEBSITE_ID = websiteId;
		window.CRISP_COOKIE_EXPIRE = 10800;

		window.CRISP_RUNTIME_CONFIG = {
			locale: languageCode
		};

		//Ще го зареждаме през tag manager-а
		//(function () {
		//let d = document;
		//let s = d.createElement("script");
		//s.src = "https://client.crisp.chat/l.js";
		//s.async = 1;
		//d.getElementsByTagName("head")[0].appendChild(s);
		//})();


		window.CRISP_READY_TRIGGER = () => {
			this._crispChatInitWelcome(componentData);
		};

		// Event for tag manager to load chat js file
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({event: 'sh_crisp_config_loaded'});
	}

	_crispSetLocalConfig = (arrCrispConfig) => {
		const data = this.context.get(this.componentName).componentData;
		arrCrispConfig = JSON.stringify(arrCrispConfig);
		HelperCookie.setCookie('sh_crisp_chat_config', arrCrispConfig, 1, data.cookieServer);

	}

	_crispGetLocalConfig = () => {
		let chatSessionId = window.$crisp.get("session:identifier");
		let arrCrispConfig = HelperCookie.getCookie('sh_crisp_chat_config');

		if (arrCrispConfig) {
			arrCrispConfig = JSON.parse(arrCrispConfig);
		} else {
			arrCrispConfig = {};
		}

		if (arrCrispConfig.sessionId !== chatSessionId) {
			arrCrispConfig = {};
		}

		arrCrispConfig.sessionId = chatSessionId;
		const data = this.context.get(this.componentName).componentData;
		HelperCookie.setCookie('sh_crisp_chat_config', JSON.stringify(arrCrispConfig), 1, data.cookieServer);
		return arrCrispConfig;
	}

	_crispGetConfigValue = (key) => {
		const arrCrispConfig = this._crispGetLocalConfig();
		return arrCrispConfig[key];
	}

	_crispUpdateConfigValue = (key, value) => {
		let arrCrispConfig = this._crispGetLocalConfig();
		arrCrispConfig[key] = value;
		this._crispSetLocalConfig(arrCrispConfig);
	}

	_crispSendAutoMessage = (messageText, arrSegmentsSet) => {
		let welcomeSent = this._crispGetConfigValue('auto_message_shown');

		if (welcomeSent) {
			return;
		}

		window.$crisp.push(["do", "message:show", ["text", messageText]]);

		if (typeof arrSegmentsSet === 'object') {
			window.$crisp.push(["set", "session:segments", [arrSegmentsSet]]);
		}

		this._crispUpdateConfigValue('auto_message_shown', 1);
	}

	_crispChatInitWelcome = (componentData) => {
		if (document.getElementsByClassName('cc-5ekd')[0]) {
			document.getElementsByClassName('cc-5ekd')[0].outerHTML = "";
		}

		const {
			sendAutoMessageIfAvailable,
			arrAutoMessages,
			isCustomerLoggedIn,
			showDepartmentPicker
		} = componentData;

		/**
		 * https://jira.superhosting.bg/browse/TP-473
		 */
		window.$crisp.push(["on", "message:sent", (data) => {
			if (data.type == 'file') {
				let isFileMessageSent = sessionStorage.getItem('is_fmsgsent');
				if (isFileMessageSent) {
					return;
				}
				window.$crisp.push(["do", "message:send", ["text", "прикачен файл"]]);
				sessionStorage.setItem('is_fmsgsent', 1)
			}
		}]);

		/**
		 */

		if (sendAutoMessageIfAvailable) {
			let welcomeSent = this._crispGetConfigValue('auto_message_shown');
			let messageShown = false;


			if (!welcomeSent) {
				window.$crisp.push(["on", "message:sent", (data) => {
					this._crispUpdateConfigValue('auto_message_shown', 1);
				}]);

				if (arrAutoMessages.length !== 0) {
					arrAutoMessages.map((pageConfig) => {
						if (messageShown) {
							return false;
						}

						let {
							site_version,
							onevent,
							delay,
							message,
							segments
						} = pageConfig;
						if (site_version !== '') {
							if ((site_version === 'MOBILE') && (window.innerWidth >= 900)) {
								return false;
							}
							if ((site_version === 'DESKTOP') && (window.innerWidth < 900)) {
								return false;
							}
						}

						window.setTimeout(() => {
							if (onevent === 'ON_LEAVE_INTENT') {
								document.addEventListener("mouseleave", () => {
									this._crispSendAutoMessage(message, segments);

									document.removeEventListener("mouseleave", () => {
									});
								});
							} else {
								this._crispSendAutoMessage(message, segments);
							}

							messageShown = true;
						}, (parseInt(delay) * 1000));

					});

				}
			} else {
				if (isCustomerLoggedIn) {
					let isAutoMessageMarkedAsRead = this._crispGetConfigValue('auto_message_read');

					if (!isAutoMessageMarkedAsRead) {
						window.$crisp.push(["do", "message:read"]);
						this._crispUpdateConfigValue('auto_message_read', 1);
					}
				}
			}
		}
		if (showDepartmentPicker) {
			let pickerShown = this._crispGetConfigValue('department_picker_shown');

			if (!pickerShown) {
				window.$crisp.push(["on", "message:sent", (data) => {
					this._crispUpdateConfigValue('department_picker_done', 1);
				}]);
			}

			window.$crisp.push(["on", "chat:opened", () => {
				this._crispChatShowPickerDepartment();
			}]);
		}
	}

	_crispChatShowPickerDepartment = () => {
		let departments = ["sales", "tech"];

		let greetings = {
			sales: this.greetings.greeting_sales,
			tech: this.greetings.greeting_support,
		};

		///////////////////////////////////////////////////////////////////////////////

		if (window.$crisp.is("session:ongoing")) {
			this._crispUpdateConfigValue('department_picker_shown', 1);
			this._crispUpdateConfigValue('department_picker_done', 1);
		}

		let pickerShown = this._crispGetConfigValue('department_picker_shown');

		if (!pickerShown) {
			window.$crisp.push(["do", "message:show", ["picker", {
				"id": "routing",
				"text": this.greetings.can_we_help,
				"choices": [{
					"value": "sales",
					"label": this.greetings.name_sales,
					"selected": false
				}, {
					"value": "tech",
					"label": this.greetings.name_support,
					"selected": false
				}]
			}]]);

			this._crispUpdateConfigValue('department_picker_shown', 1);

			window.$crisp.push(["on", "message:received", (data) => {
				let pickerDone = this._crispGetConfigValue('department_picker_done');

				if (data.origin !== "update") {
					return;
				}
				if (!data.content.choices) {
					return;
				}
				if (pickerDone) {
					return;
				}

				for (let index in data.content.choices) {
					let current = data.content.choices[index];
					if (current.selected && departments[current.value] !== -1) {
						window.$crisp.push(["set", "session:segments", [[current.value]]]);
						window.$crisp.push(["do", "message:show", ["text", greetings[current.value]]]);
						this._crispUpdateConfigValue('department_picker_done', 1);
						return;
					}
				}
			}]);
		}

		return null;
	}

	_crispResetSession = () => {
		window.$crisp.push(["do", "session:reset", [true]]);
	}

	render() {

		const lawBanner = HelperCookie.getCookie('sh_hdgbar');
		if (lawBanner === '') {
			const existingStyle = document.getElementById('lawBannerStyle');
			if (existingStyle === null) {
				const css = '#crisp-chatbox>div>a{bottom:130px !important;}',
				  head = document.head || document.getElementsByTagName('head')[0],
				  style = document.createElement('style');

				head.appendChild(style);
				style.appendChild(document.createTextNode(css));
				style.setAttribute('id', 'lawBannerStyle');
			}
		}
		return null;
	}
}


// React Context binding
ComponentCrispChat.contextType = ContextDataStore;

export default ComponentCrispChat;
